import React from 'react';
import classNames from 'classnames';

export interface NoteProps {
  title?: string;
  caption?: string;
  displayText?: string;
  state?: 'info' | 'error';
  className?: string;
  children?: React.ReactNode;
}

export const Note: React.FC<NoteProps> = ({
  title,
  caption,
  displayText,
  state = 'info',
  className,
  children,
}) => {
  const isError = state === 'error';
  const containerClasses = classNames(
    'flex flex-col gap-6 pt-5 pb-6 px-5 rounded-ds-5',
    {
      'bg-ds-bg-feedback-soft-info': !isError,
      'bg-ds-bg-feedback-soft-error': isError,
    },
    className,
  );
  return (
    <div className={containerClasses}>
      {title && <p className="text-ds-subtitle font-ds-600 text-ds-text-4">{title}</p>}
      {(caption || children) && (
        <div className="flex flex-col gap-2">
          {caption && <p className="text-ds-caption font-ds-500 text-ds-text-3">{caption}</p>}
          {children && <div className="text-ds-text-s font-ds-400 text-ds-text-1">{children}</div>}
        </div>
      )}
      {displayText && <p className="text-ds-display font-light text-ds-text-1">{displayText}</p>}
    </div>
  );
};
